/* eslint-disable import/no-unassigned-import */

// Polyfills for IE 11
require('core-js')
require('whatwg-fetch')
require('./cxf-ie11-patch')

console.log('cxf bundled with env: ', process.env.NODE_ENV)
require('dom-loaded').then(() => {
  const element = document.getElementById('plugins')
  const url = element && element.getAttribute('data')
  require('./cxf-plugin-loader')(url)

  // Create a CXF instance
  window.CXF = require('./cxf-runtime')()

  // Mix in game-related functions
  // - onServerCommandReceived
  // - UIButtonClicked
  Object.assign(
    window,
    require('./cxf-game')(window.CXF),
  )

  // Tell the world we’re ready
  const event = new Event('cxf.initialized')
  event.cxf = window.CXF
  window.dispatchEvent(event)
})
